import { getContext, invoke } from './core';
import { bridgeConfigDelegates } from './bridge-config-delegates';
import { fetchProduct } from './fetchProduct';
import { on, emit } from './events';

export const bridgeMethods = {
	...bridgeConfigDelegates,
	// Core methods
	getContext,
	invoke,
	fetchProduct,
	// Event methods
	on,
	emit,
};
